import { Input } from "antd-mobile";
import isEqual from "lodash/isEqual";
import React, { useEffect, useMemo, useState } from "react";
import AreaPicker, { AreaPickerValue } from "./AreaPicker";
import styles from "./styles.module.scss";

interface AreaPickerProps {
  placeholder?: string; // picker是否显示
  className?: string;
  value?: AreaPickerValue[];
  onChange?: (val: AreaPickerValue[]) => void;
}

const Area: React.FC<AreaPickerProps> = (props) => {
  const [state, setState] = useState<AreaPickerValue[]>([]);
  const [visible, setVisible] = useState<boolean>(false);
  useEffect(() => {
    if (!isEqual(props.value, state)) {
      setState(props.value || []);
    }
  }, [props.value]);

  const showText = useMemo(() => {
    return state.map((item) => item.label).join(" ");
  }, [state]);

  return (
    <div>
      <div onClick={() => setVisible(true)} className={styles.input}>
        <Input readOnly value={showText} placeholder={props.placeholder} />
      </div>
      <AreaPicker
        visible={visible}
        onClose={() => setVisible(false)}
        onConfirm={(value) => {
          const _value = value || [];
          setState(_value);
          typeof props.onChange === "function" && props.onChange(_value);
        }}
      />
    </div>
  );
};

export default Area;
